module.exports = __webpack_public_path__ + "static/media/opw.20627b97.png";